import { useMemo } from 'react';

function useMetric({ currentMetrics, selectedMetricList, lockedMetricsSet }) {
  const metricList = useMemo(() => {
    const metrics = currentMetrics.reduce((acc, metric) => {
      if (!metric.active || metric.relatedAvgMetric) {
        return acc;
      } else {
        if (metric['percentileMetrics']) {
          metric['percentileMetrics'].forEach((it) => {
            it.checked = selectedMetricList.includes(it.name);
            it.disabled = lockedMetricsSet.has(it.name);
          });
        }
        acc.push({
          key: metric.name,
          label: metric.displayName,
          checked: selectedMetricList.includes(metric.name),
          unit: metric.unit,
          name: `${metric.displayName} ${metric.subscript}`,
          disabled:
            lockedMetricsSet.has(metric.name) ||
            ['undefined', 'in_progress'].includes(metric.definitionStatus),
          isHeavyMetric: metric.isHeavyMetric ?? false,
          definitionStatus: metric.definitionStatus ?? 'defined',
          percentileMetrics: metric.percentileMetrics ?? [],
          isDeployed: metric.isDeployed ?? true,
        });
        return acc;
      }
    }, []);

    // sort the metrics by name
    metrics.sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

    return metrics;
  }, [selectedMetricList, currentMetrics]);
  return {
    metricList,
    allSelected: metricList.every((metric) => metric.checked),
  };
}

export default useMetric;
